import * as React from "react";
const SvgLightingProd = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.388 7.945a2.697 2.697 0 0 1-.999-3.726l.186-.316A2.804 2.804 0 0 1 9.362 2.89l5.459 3.093.117-.014 5.496-.65a.753.753 0 0 1 .717.328.736.736 0 0 1 .02.781l-5.757 9.786a.765.765 0 0 1-.7.374.747.747 0 0 1-.647-.445l-2.175-4.996-.046-.108-2.3-1.303v6.14l5.052 4.275a.75.75 0 0 1-.969 1.145l-4.084-3.456v2.883a.75.75 0 0 1-1.5 0v-2.883l-4.083 3.456a.75.75 0 1 1-.97-1.145l5.053-4.276v-6.99l-1.657-.939Zm2.214-3.763 5.277 2.99-1.454 2.47-5.277-2.99a1.226 1.226 0 0 1-.454-1.693l.186-.316a1.275 1.275 0 0 1 1.722-.461Zm4.829 6.71 1.434 3.296 4.244-7.215-3.625.429-2.053 3.49Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLightingProd;
